// Libraries
import React, {FunctionComponent} from 'react';
import {Table} from 'antd';
import PropTypes from 'prop-types';

// Types
import {PaginationType} from '../../types/SharedTypes';


type TableComponentType = {
  pageSize: number;
  currentPage: number;
  total: number;
  scrollX: number;
  filterText?: string;
  rowKey: string;
  className?: string;
  dataSource: any[];
  columns: any[];
  onChangePage: (pagination: PaginationType) => void;
};
const TableComponent: FunctionComponent<TableComponentType> = (
  {
    pageSize, currentPage, total, scrollX, filterText,
    rowKey, className, dataSource, columns, onChangePage
  }) => {
  return (
    <Table dataSource={dataSource} rowKey={rowKey} size={'small'}
           className={className}
           columns={columns}
           scroll={{ x: scrollX }}
           pagination={{
             size: 'small',
             pageSize: pageSize,
             current: currentPage,
             showSizeChanger: true,
             total: total,
             onChange: (page, pageSize) => onChangePage({ page: page, size: pageSize }),
           }} />
  );
}

TableComponent.propTypes = {
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  scrollX: PropTypes.number.isRequired,
  rowKey: PropTypes.string.isRequired,
  className: PropTypes.string,
  dataSource: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

export default TableComponent;